
<template>
  <div class="ticker-band">
    <div 
      class="ticker-inner" 
      v-html="tickerContent"
      v-bind:style=" { '-webkit-animation': 'marquee ' + time + 's linear infinite', 'animation' : 'marquee ' + time + 's linear infinite' } "
    ></div>
    <div 
      class="ticker-inner-2" 
      v-html="tickerContent"
      v-bind:style=" { '-webkit-animation': 'marqueetwo ' + time + 's linear infinite', 'animation' : 'marqueetwo ' + time + 's linear infinite' } "
    ></div>
  </div>
</template>

<style>

.ticker-band {
  height: 60px;
  background-color: #ec7d8d;
  line-height: 60px;
  color: #d1a699;
  font-size: 16px;
  text-transform: uppercase;
  font-family: 'druk-super', "Helvetica Neue", Helvetica, Arial, sans-serif!important;
  -webkit-perspective: 1000;
-webkit-backface-visibility: hidden;
}
.ticker-inner {
/*  display: flex;*/
  white-space: nowrap;
  position: absolute;
  -webkit-perspective: 1000;
-webkit-backface-visibility: hidden;
}
.ticker-inner-2 {
/*  display: flex;*/
  white-space: nowrap;
  position: absolute;
  padding-left: 7px;
}
.ticker-entry {
  display: inline-block;
}

@-webkit-keyframes marquee {
  0% { -webkit-transform: translateX(0%); }
  100% { -webkit-transform: translateX(-100%); }
}
@keyframes marquee {
  0% { transform: translateX(0%); }
  100% { transform: translateX(-100%); }
}
@-webkit-keyframes marqueetwo {
  0% { -webkit-transform: translateX(100%); }
  100% { -webkit-transform: translateX(0%); }
}
@keyframes marqueetwo {
  0% { transform: translateX(100%); }
  100% { transform: translateX(0%); }
}

@media (min-width: 576px) {

}
@media (min-width: 768px) {

}
@media (min-width: 992px) {
  .ticker-band {
    height: 80px;
    line-height: 80px;
    font-size: 20px;
  }
}
@media (min-width: 1200px) {
  
}


</style>

<script>
// import Vue from 'vue'
import {ticker} from '../../content.json'

export default {
  props: ['page'],
  data: function () {
    return {
      paddingTop: 0,
      ticker,
      tickerType: '',
      tickerContent: '',
      time: 0
    }
  },
  methods: {
    getTickerData: function () {
      this.ticker[this.tickerType].map((e) => {
        this.time += 2
        this.tickerContent += e.entry + ' | '
      })
      // let ticker = document.querySelector('.ticker-band')
      // let list = document.querySelector('.ticker-inner')
      // let clone = list.cloneNode(true)
      // ticker.append(clone)
    }
  },
  mounted: function () {
    this.tickerType = this.page
    this.getTickerData()
  }
}
</script>



// WEBPACK FOOTER //
// TextTicker.vue?643a9608